import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarningFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={10} r={8} />
    <path
      fill="#fff"
      d="M11 13.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0M9.2 10.4a.8.8 0 0 0 1.6 0V6a.8.8 0 0 0-1.6 0z"
    />
  </svg>
);
export default SvgWarningFull;
